import { Endpoint, EndpointRoutes } from '../endpoint.interface';

export interface RolesEndpointRoutes extends EndpointRoutes {
  roles: {
    toString: () => string;
    getRoles: {
      toString: () => string;
      addRoles: {
        toString: () => string;
      };
      update: {
        toString: () => string;
      };
      getRemoveRoleState: {
        toString: () => string;
      };
      delete: {
        toString: () => string;
      };
    };
  };
}
export interface RolesEndpoint extends Endpoint {
  baseUrl: string;
  routes: RolesEndpointRoutes;
}
